import {EventBroker} from "@frontend/lib/utils/event-broker";

export const EVENTS = {
    INIT: 'INIT',
    CLOSED: 'CLOSED',
}

export const extractClaimsEventBroker = new EventBroker();
